import { Image } from "@mantine/core";

export interface CitationImageProps {
    src: string | null;
}

export const CitationImage = ({ src }: CitationImageProps) => {
    if (!src) {
        return null;
    }
    return <Image radius="md" src={src} fallbackSrc="https://placehold.co/600x400?text=There was a problem loading the Image" />;
};
